export default __webpack_public_path__ + "static/media/south_east.bcd01cf9.svg";